export enum MetodoValidadorVariavel{
  VALIDA_CPF = "Validação de CPF",
  VALIDA_CNPJ = "Validação de CNPJ",
  VALIDA_EMAIL = "Validação de E-mail",
  VALIDA_TELEFONE = "Validação de Telefone"
}
